import { Fascicolo } from './fascicolo';
import { IntestazioneFascicolo } from './intestazione-fascicolo';

export class FascicoloBase extends Fascicolo {
    intestazione: IntestazioneFascicolo;
}
